"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1687))
 * @lastsynced 2026-10-29T13:55:02.642Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const TrashCan = createSVGIcon(
  <path
    d="M1.714 6h20.572M7.714 6v-.857a4.286 4.286 0 1 1 8.572 0V6M9.429 9.429v9.428m5.143-9.428v9.428M4.286 6h15.429v15.429A1.715 1.715 0 0 1 18 23.143H6a1.715 1.715 0 0 1-1.714-1.714z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "TrashCan",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "tv4IoW",
      defaultMessage: "Remove",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  })
);
